module.exports = __webpack_public_path__ + "DINNextLTPro-Condensed.woff?680d13d70cf22b6118c7c4b2464aaa9c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Condensed.woff
// module id = 1401
// module chunks = 0